import "./styles.css";
import React, { useState, useEffect } from "react";
import { FaIdCard } from 'react-icons/fa';
import { IoMdCheckboxOutline } from "react-icons/io";
import { FaExclamationCircle } from 'react-icons/fa';
import { format, toZonedTime } from 'date-fns-tz';
import { addHours } from 'date-fns';
import api from "../../Services/api";

const formatarDataHora = (datahora) => {
  const timeZone = 'America/Sao_Paulo';
  const dataZoned = toZonedTime(datahora, timeZone);
  const dataSomada = addHours(dataZoned, 0);
  const formato = 'dd/MM/yyyy HH:mm:ss';
  return format(dataSomada, formato);
};

const ListaMovimentos = ({ listaMovimento, maxHeight }) => {
  const [ocorrencias, setOcorrencias] = useState({}); // Armazena as ocorrências por IDvisita

  useEffect(() => {
    const carregaDadosOcorrencia = async (idvisita) => {
      if (!ocorrencias[idvisita]) { // Evita buscar novamente se já foi carregado
        const retorno = await buscaDadosOcorrencia(idvisita);
        if (retorno) {
          setOcorrencias((prev) => ({ ...prev, [idvisita]: retorno.data }));
        }
      }
    };

    // Filtra os movimentos de tipo 5 e carrega os dados da ocorrência
    listaMovimento?.resultMovimentos
      ?.filter((mov) => mov.tipo === 5)
      .forEach((mov) => carregaDadosOcorrencia(mov.IDvisita));
  }, [listaMovimento, ocorrencias]);

  const buscaDadosOcorrencia = async (idvisita) => {
    try {
      const response = await api.get('/itensocorrencia/' + idvisita);
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  return (
    <div
      className="card-container-mov"
      style={{
        maxHeight: maxHeight || '40%',
        overflowY: 'auto',
        padding: '10px',
      }}
    >
      {listaMovimento?.resultMovimentos
        ?.filter((mov) => mov.situacao === 1)
        .map((mov) => (
          <div key={mov.IDmovimento} className="card-mov">
            <div className="card-content-mov">
              <div className="row">
                <div className="col-sm-3">

                  {mov.tipo === 5 ? (
                    <FaExclamationCircle
                      style={{
                        marginRight: '8px',
                        marginLeft: '5%',
                        color: 'red',
                        fontSize: '18px',
                        fontWeight: 'bold',
                      }}
                    />
                  ) : (
                    <IoMdCheckboxOutline
                      style={{
                        marginRight: '8px',
                        marginLeft: '5%',
                        color: 'green',
                        fontSize: '30px',
                        fontWeight: 'bold',
                      }}
                    />
                  )}


                  {(() => {
                    switch (mov.tipo) {
                      case 1:
                        return 'Chegou no local.';
                      case 2:
                        return 'Começou entrega.';
                      case 3:
                        return 'Colheu assinatura.';
                      case 4:
                        return 'Finalizou entrega.';
                      case 5:
                        return 'Ocorrência.';
                      default:
                        return mov.tipo;
                    }
                  })()}
                </div>
                <div className="col-sm-4">
                  <FaIdCard style={{ marginRight: '8px', marginLeft: '25px' }} />
                  {formatarDataHora(mov.datahora)}
                </div>
              </div>

              {/* Exibir informações da ocorrência quando for tipo 5 */}
              {mov.tipo === 5 && ocorrencias[mov.IDvisita] && (
                <div className="col-sm-12 ocorrencia-detalhes">
                  <br />
                  {ocorrencias[mov.IDvisita].map((ocorrencia, index) => (
                    <div key={index} style={{ paddingLeft: '4%', fontSize: '0.7em' }}>
                      {ocorrencia.registro?.map((reg, regIdx) => (
                        <div key={regIdx} style={{ marginBottom: '10px' }}>
                          <p><strong>Tipo de Ocorrência {' - '}</strong> {reg.TipoOcorrencia}</p>
                          <p><strong>Observação {' - '}</strong> {reg.Observacao}</p>
                          <p><strong>Produtos :</strong></p>
                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr>
                                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>ID</th>
                                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Descrição</th>
                                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'right' }}>Qtde na Ocorrência</th>
                                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'right' }}>Preço Uni (R$)</th>
                                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'right' }}>Qtde Total</th>
                                <th style={{ borderBottom: '1px solid #ccc', textAlign: 'right' }}>Total (R$)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reg.Produtos?.map((produto, idx) => (
                                <tr key={idx}>
                                  <td>{produto.IDproduto}</td>
                                  <td>{produto.descricao}</td>
                                  <td style={{ textAlign: 'right' }}>{produto.quantidadeNaOcorrencia}</td>
                                  <td style={{ textAlign: 'right' }}>{Number(produto.precouni).toFixed(2)}</td>
                                  <td style={{ textAlign: 'right' }}>{produto.qtde}</td>
                                  <td style={{ textAlign: 'right' }}>{Number(produto.precototal).toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <br /><br />
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}

            </div>
          </div>
        ))}
    </div>
  );
};

export default ListaMovimentos;
